import { PageContainer } from "@/components/container/page-container";
import { PrivacyAgreementContent } from "@/pages/welcome-screen/privacy-content";

export default function PublicPrivacyPage() {
  return (
    <PageContainer
      showToolbar={false}
      className="app-bar-bottom-padding no-scrollbar h-full w-full overflow-y-auto"
    >
      <div className="mx-auto max-w-4xl px-6 py-8">
        <PrivacyAgreementContent />
      </div>
    </PageContainer>
  );
}
